<template>
  <div class="account-warpper">
    <div class="bg-white ">
      <div class="margin-bottom-sm flex align-center justify-between">
        <div class="flex align-center">
          <div class="flex align-center margin-right-sm">
            <span>姓名：</span>
            <el-input v-model="searchName" placeholder="请输入姓名" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm">
            <span>手机号：</span>
            <el-input v-model="searchPhone" placeholder="请输入手机号" class="flex-sub"></el-input>
          </div>
          <div class="flex align-center margin-right-sm">
            <span>角色：</span>
            <el-select v-model="power" placeholder="请选择角色" class="flex-sub">
              <el-option
                  v-for="item in powerList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
              </el-option>
            </el-select>
          </div>
          <el-button type="primary" @click="hanldSearch">搜索</el-button>
        </div>
        <el-button type="primary" @click="accountDialog = true">新增账号</el-button>
      </div>
      <el-table
          :data="accountList"
          header-row-class-name="table-header"
          row-class-name="table-row"
          alig="center"
          border
          style="width: 100%"
      >
        <el-table-column width="70" type="index" align="center" label="序号">
        </el-table-column>
        <el-table-column label="姓名" prop="name"></el-table-column>
        <el-table-column label="手机号码" prop="username"></el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope">
            <div>
              {{ scope.row.power | power }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope">
            <div>
              {{ scope.row.user_lock === 0 ? "正常" : "停用" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="600">
          <template slot-scope="scope">
            <div class="table-operate">
              <el-button
                  size="small"
                  type="primary"
                  @click="editItem(scope.row)"
                  v-if="!scope.row.user_lock"
              >编辑
              </el-button>
              <el-button
                  size="small"
                  type="primary"
                  @click="setLockItem(scope.row.id,1)"
                  v-if="!scope.row.user_lock"
              >停用
              </el-button>
              <el-button
                  size="small"
                  type="success"
                  @click="setLockItem(scope.row.id,0)"
                  v-if="scope.row.user_lock"
              >启用
              </el-button>
              <el-button
                  size="small"
                  type="primary"
                  @click="initialItem(scope.row.id)"
                  v-if="!scope.row.user_lock"
              >初始化密码
              </el-button>
              <el-button
                  size="small"
                  type="primary"
                  @click="deleteItem(scope.row.id)"
              >删除
              </el-button>
              <el-button
                  v-if="scope.row.power === 6 && [3,5].includes(user.power) && !scope.row.user_lock"
                  size="small"
                  type="primary"
                  @click="regionItem(scope.row.xiangmu_id,scope.row)"
              >区域分配
              </el-button>
              <el-button size="small" type="primary" @click="setImg(scope.row)"  v-if="scope.row.power === 6 || scope.row.power === 5">头像上传</el-button>
<!--              <router-link :to="'/staff?id=' + scope.row.id" class="margin-left-xs" target="_blank">-->
<!--                <el-button size="small" type="primary"   v-if="scope.row.power === 6 ">数据统计</el-button>-->
<!--              </router-link>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          v-if="accountList.length > 0"
          class="page-all"
          background
          @current-change="getAdminList"
          :current-page.sync="page"
          :page-size="limit"
          layout="prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
    </div>
    <accountDialog
        :setId="setId"
        :setItem="setItem"
        :accountDialog="accountDialog"
        @cancelDialog="cancelDialog"
    />
    <regionDialog
        :setId="setId"
        :setItem="setItem"
        :regionDialog="regionDialog"
        @cancelDialog="cancelDialog"
    />
    <imgDialog
      :setId="setId"
      :setItem="setItem"
      :imgDialog="imgDialog"
      :type="1"
      @cancelDialog="cancelDialog"
    />

  </div>
</template>

<script>
import {adminAccountDel, getAdminList, setLock, setPass} from "@/api/login";
import accountDialog from "@/views/pages/dialog/accountDialog";
import regionDialog from "@/views/pages/dialog/regionDialog";
import imgDialog from "@/views/pages/dialog/imgDialog";
import { powerTypes} from "@/utils/utils";
export default {
  name: "account",
  data() {
    return {
      searchName: '',
      searchPhone: '',
      power: 0,
      powerArr: [
        {value: 0, label: '全部'},
        {value: 4, label: '子管理员'},
        {value: 5, label: '社区'},
        {value: 6, label: '志愿者队长'},

        {value: 8, label: '志愿者'},
      ],
      page: 1,
      limit: 10,
      total: 0,
      accountList: [],
      setId: 0,
      setItem: {},
      accountDialog: false,
      regionDialog: false,
      imgDialog:false
    }
  },
  created() {
    this.$emit("setIndex", this.$route.path, "系统管理 / 账号管理", false);
    this.getAdminList()
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    powerList() {
      if (this.user.power === 5) {
        return [this.powerArr[0], this.powerArr[3], this.powerArr[4]]
      } else {
        return this.powerArr
      }
    }
  },
  components: {
    accountDialog,
    regionDialog,
    imgDialog
  },
  methods: {
    //  区域分配
    regionItem(id,obj){
      this.setId = id;
      this.setItem = obj;
      this.regionDialog = true;
    },
    //  删除账号
    deleteItem(id){
      this.$confirm('您确定要删除该账号吗？', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      let _state = await adminAccountDel(id);
      if (this.accountList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getAdminList();
      this.$message.success(_state.info);
    },
    //  初始化密码
    initialItem(id){
      this.$confirm('初始化密码后该账号密码为Aa123456', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureInitial(id);
      });
    },
    async sureInitial(id){
      let _state = await setPass(id);
      this.$message.success(_state.info);
    },
    //  账号停用/启用
    setLockItem(id,state){
      this.$confirm(state?'您确定要停用该账号吗？':'您确定要启用该账号吗', "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureSetLock(id,state);
      });
    },
    async sureSetLock(id,state){
      let _state = await setLock(id,state);
      this.$message.success(_state.info);
      this.getAdminList();

    },
    //  编辑
    editItem(obj) {
      this.setItem = obj;
      this.setId = obj.id;
      this.accountDialog = true;
    },
    setImg(obj){
      this.setItem = obj;
      this.setId = obj.id;
      this.imgDialog = true;
    },
    //  员工信息编辑后回调
    cancelDialog(val) {
      if (val) {
        this.setId = 0;
        this.setItem = {};
        this.accountDialog = false;
        this.regionDialog = false;
        this.imgDialog = false;
        this.getAdminList();
      } else {
        this.setId = 0;
        this.setItem = {};
        this.regionDialog = false;
        this.accountDialog = false;
        this.imgDialog = false;
      }
    },
    //  搜索
    hanldSearch(){
      this.page = 1
      this.getAdminList()
    },
    //  获取列表
    async getAdminList() {
      let _list = await getAdminList(this.searchName, this.searchPhone,this.power, this.page, this.limit)
      this.accountList = _list.data
      this.total = _list.total_number
    }
  },
  filters: {
    power(val){
      return powerTypes(val)
    }
  },
  watch: {},
}
</script>

<style scoped lang="scss">

</style>
